import Validation from '../helpers/Validation';

class ForgotPassword {
  private readonly changePasswordForm: HTMLFormElement | null;
  private readonly formElements: any;
  private errorCount: number;
  private submitCount: number;
  private validationMessages: any;

  constructor() {
    // Get the change password form
    this.changePasswordForm = document.querySelector('#frmChangePassword');

    // validation messages
    this.validationMessages = (window as any).validationMessages.forgotPassword;

    this.formElements = {
      email: {
        id: 'Email',
        type: 'email',
        required: true,
        regex:
          '^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$',
        errorMessage: {
          empty: this.validationMessages.emailRequired,
          invalid: this.validationMessages.emailInvalid
        },
        minChar: 3,
        maxChar: 150
      }
    };

    // error count for validation
    this.errorCount = 0;
    this.submitCount = 0;

    // default events
    this.events();
  }

  /**
   * @define events
   * @description default events when page loaded
   */
  events() {
    const self = this;

    // Validate on submit
    self.changePasswordForm?.addEventListener('submit', (e) => {
      e.preventDefault();
      self.errorCount = 0;
      self.validateOnSubmit();
      self.submitCount++;
      if (self.errorCount === 0) {
        self.submitForm();
      }
    });

    // Validate on entry
    self.validateOnEntry();
  }

  /**
   * @define validateOnSubmit
   * @description validate on submit
   */
  validateOnSubmit() {
    const self = this;

    // for loop to get all form elements
    for (const key in self.formElements) {
      if (self.formElements.hasOwnProperty(key)) {
        // Get the form element
        const formElementInfo = self.formElements[key];

        if (formElementInfo.type === 'email') {
          if (!Validation.prototype.validateEmail(formElementInfo)) {
            self.errorCount++;
          }
        }
      }
    }
  }

  /**
   * @define validateOnEntry
   * @description validate on entry and if try submit least one time
   */
  validateOnEntry() {
    const self = this;

    // for loop to get all form elements
    for (const key in self.formElements) {
      if (self.formElements.hasOwnProperty(key)) {
        // Get the form element
        const formElementInfo = self.formElements[key];
        const input = document.getElementById(formElementInfo.id);

        input?.addEventListener('input', () => {
          if (self.submitCount > 0) {
            if (formElementInfo.type === 'email') {
              if (!Validation.prototype.validateEmail(formElementInfo)) {
                self.errorCount++;
              }
            }
          }
        });
      }
    }
  }

  /**
   * @define submitForm
   * @description trigger submit again
   */
  submitForm() {
    this.changePasswordForm?.submit();
    this.submitCount = 0;
    (window as any).OGOO.layoutLoader.showLoader();
  }
}

new ForgotPassword();
